define(function(require) {
  const IpsModel = require('civicsBase/ipsModel');

  return IpsModel.extend({
    urlRoot: '/delegate/civics-api/api/core/reports/{0}/properties',

  });

})
